module.exports = __webpack_public_path__ + "img/md-item09.5f05070.png";